import { Token } from '@lumino/coreutils';
/**
 * The token for the kernels service.
 */
export const IKernels = new Token('@jupyterlite/kernel:IKernels');
/**
 * The token for the kernel spec service.
 */
export const IKernelSpecs = new Token('@jupyterlite/kernel:IKernelSpecs');
